<template>
  <TheMainContent>
    <RevContainer class="py-32" data-test="customer-testing-report-page">
      <p
        v-if="status === 'pending'"
        class="body-1 mt-16"
        data-test="customer-testing-report-loading"
      >
        {{ i18n(translations.loading) }}
      </p>

      <div
        v-else-if="error"
        class="mt-16"
        data-test="customer-testing-report-error"
      >
        <h2 class="heading-2">{{ i18n(translations.errorTitle) }}</h2>
        <p class="body-1 mt-8">{{ i18n(translations.errorDescription) }}</p>
        <RevButton class="mt-16" variant="primary" @click="() => refresh()">
          {{ i18n(translations.retry) }}
        </RevButton>
      </div>

      <pre
        v-else-if="report"
        class="body-2 mt-16"
        data-test="customer-testing-report-data"
        >{{ report }}</pre>
    </RevContainer>
  </TheMainContent>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

import { useFetchCustomerTestingReport } from '../../composables/useFetchCustomerTestingReport'

import translations from './CustomerTestingReport.translations'

const i18n = useI18n()

const { report, status, error, refresh } = useFetchCustomerTestingReport()

useHead({
  meta: [{ name: 'robots', content: 'noindex, nofollow' }],
})
</script>
